module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#share",
      toString: function () {
        return this.url;
      }
    }